import { new_filter_unit_function } from '@/utils/monitor/option.js'

export const filter_same_district = (data, condition_text) => {
    const filter_callback = new_filter_unit_function(
        condition_text, 
        '轄管區', 
        '所有港口'
    )

    return data.filter(filter_callback)
}